export default "__VITE_ASSET__BVcymZ$1__"